//TODO: Student history
const attendanceModal = document.getElementById('attendanceModal');

if (attendanceModal) {
    const attendanceModalForm = attendanceModal.querySelector('form');
    const groupSelect = attendanceModalForm.querySelector('#attendanceModalGroup');
    let groupStudentList = '';

    const groupOptions = (data) => {
        if (data.length > 1) {
            data.filter((item, index) => item.del > 0).forEach((item, index) => {
                const option = new Option(item.comment, item.id);
                option.dataset.key = index + 1;
                groupSelect.add(option);
            })
        }
    }

    const attendanceStuList = (data) => {
        const stuContainer = document.getElementById('attendanceStuList');

        stuContainer.innerHTML = '';

        data.forEach((item, index) => {
            const stuRow = document.createElement('div');

            stuRow.classList.add('row', 'py-2');
            if (index % 2 === 0) stuRow.classList.add('bg-light');
            //TODO: Checkbox input - Trail Lesson
            stuRow.innerHTML = `<div class="col">${item.name} ${item.surname}</div><div class="col form-check d-flex justify-content-end align-items-center gap-2"><input class="form-check-input" type="checkbox" value="${item.id}" id="sid-${item.id}"><label class="form-check-label" for="sid-${item.id}">was present</label></div>`;
            stuContainer.appendChild(stuRow);
        })
    }

    attendanceModal.addEventListener('show.bs.modal', event => {
        const cid = event.relatedTarget.dataset.cid;
        const today = new Date().toISOString().split('T')[0];
        const attendanceModalDate = document.getElementById('attendanceModalDate');

        attendanceModalDate.value = today;
        attendanceModalDate.setAttribute('max', today);
        postData('/actions/dash/courses.php', {act: 1, cid: cid}).then(data => {
            const cidInput = document.createElement('input');
            cidInput.name = 'cid';
            cidInput.type = 'hidden';
            cidInput.value = cid;
            attendanceModalForm.appendChild(cidInput);

            groupStudentList = data;
            groupOptions(groupStudentList);
            const selectedKey = groupSelect.selectedOptions[0].dataset.key;
            attendanceStuList(groupStudentList[selectedKey]['students'])
        })
    })

    attendanceModal.addEventListener('hidden.bs.modal', event => {
        document.getElementById('attendanceModalDate').value = '';
        document.getElementById('attendanceModalGroup').innerHTML = '';
        document.getElementById('attendanceStuList').innerHTML = '';
    })

    groupSelect.addEventListener('change', (e) => {
        const selectedOption = e.currentTarget.selectedOptions[0];
        const selectedKey = selectedOption.dataset.key;
        attendanceStuList(groupStudentList[selectedKey]['students'])
    })

    const attendanceBtn = document.getElementById('attendanceBtn');
    attendanceBtn.addEventListener('click', (e) => {
        let preloader = document.createElement('div');

                preloader.classList.add('position-absolute', 'd-flex', 'align-items-center', 'justify-content-center', 'z-2');
                preloader.style.cssText = 'left: 1rem;right: 1rem;top: 1rem;bottom: 1rem;background: rgba(255,255,255, 0.5);';
                preloader.innerHTML = '<div class="spinner-border text-brand-primary" role="status"><span class="visually-hidden">Loading...</span></div>'
                document.querySelector('#attendanceModal .modal-content').appendChild(preloader);

        let attendanceValuesList = [...document.querySelectorAll('#attendanceStuList input:checked')].map(elem => elem.value);
        attendanceValuesList = JSON.stringify(attendanceValuesList);

        const formData = new FormData(attendanceModalForm);
        formData.append('stulist', attendanceValuesList);

        const values = Object.fromEntries(formData.entries());

        postData('/actions/dash/attendance.php', values).then(data => {
            console.log(data);
            if (data.success) {
                preloader.remove();
                
                document.querySelector('.toast-container').innerHTML += `<div id="liveToast" class="toast align-items-center rounded-3 text-white" role="alert" aria-live="assertive" aria-atomic="true"><div class="d-flex"><div class="toast-body pt-3 ps-3">${data.success}</div><button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div></div>`;
                const toastLive = document.getElementById('liveToast')
                const toastBootstrap = bootstrap.Toast.getOrCreateInstance(toastLive);
                toastBootstrap.show();
                toastLive.addEventListener('hidden.bs.toast', () => {
                    toastLive.remove();
                });

                let modal = bootstrap.Modal.getInstance(attendanceModal);
                modal.hide();
            }
        }).catch(error => console.error(error));
    })
}